module.exports = __webpack_public_path__ + "img/tip-five.b7826d18.png";